import { Button } from "components/atoms";
import contract from "components/molecules/contract";
import {
  ContractForm,
  ContractTabs,
} from "components/organisms/forms/contract/ContractForm";
import { useContractParamIds } from "hooks";
import { useParamId } from "hooks/useParamId";
import { contractMiddleware } from "middleware/contract/contractMiddleware";
import { useTranslation } from "react-i18next";
import { PiCheck, PiX, PiXCircle } from "react-icons/pi";
import { useLocation } from "react-router-dom";
import {
  useAcceptContract,
  useGetContract,
  useRejectContract,
} from "services/contract";
import { CONTRACT_STATUS } from "services/contract/types";
import { BUTTON_VARIANT } from "types/components/button/button.interface";

const Contract = () => {
  const { t } = useTranslation();
  const contractId = useParamId("/contracts");
  const location = useLocation();

  const contract = useGetContract(contractId);

  const finalBackPath =
    location.state === "contracts"
      ? "contracts"
      : location.state === "contracts-to-expire"
      ? "contracts-to-expire"
      : "contracts";

  const initialValues = {
    ...contract.data!,
    sortedSections: contractMiddleware.toOrderedSections(contract.data!),
  };

  const acceptContract = useAcceptContract();
  const rejectContract = useRejectContract();

  const handleReject = () => {
    rejectContract.mutateAsync(
      { contractId: contractId },
      { onSuccess: () => contract.refetch() }
    );
  };

  const handleAccept = () => {
    acceptContract.mutateAsync(
      { contractId: contractId },
      { onSuccess: () => contract.refetch() }
    );
  };

  return (
    <ContractForm
      backPath={finalBackPath}
      title={initialValues.title}
      topbarContent={
        <>
          {/* {initialValues.status === CONTRACT_STATUS.offer && (
            <div className="flex gap-4">
              <Button
                onlyIcon
                isClear
                onClick={handleReject}
                outsideChildren={
                  <Button.Description description={t("button.reject")} />
                }
              >
                <Button.Icon icon={<PiX />} />
              </Button>
              <Button
                onlyIcon
                variant={BUTTON_VARIANT.submit}
                onClick={handleAccept}
                outsideChildren={
                  <Button.Description description={t("button.accept")} />
                }
              >
                <Button.Icon icon={<PiCheck />} />
              </Button>
            </div>
          )} */}
        </>
      }
      withTabs
      disabledTabs={[]}
      initialValues={initialValues}
      onSubmit={() => {}}
    />
  );
};

export default Contract;
